// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3FD6u","detailsBorder":"styles_detailsBorder__1wFSI"};